import { useState, useEffect } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { getPublicData } from "../lib/api";

export function usePublicData() {
  const { token, settings } = useOutletContext();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getPublicData(token);
        setData(res.data);
      } catch (err) {
        setError("Tournament not found or not available");
        navigate("/");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [token, navigate]);

  return { data, loading, error, token, settings };
}
